import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { FILE_PICKER_CONSTANTS } from './file-picker-constants';
import { BaseAdapter } from '../core';
var FilePickerAdapter = /** @class */ (function (_super) {
    __extends(FilePickerAdapter, _super);
    function FilePickerAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._container = getShadowElement(component, FILE_PICKER_CONSTANTS.selectors.CONTAINER);
        _this._buttonSlot = getShadowElement(component, FILE_PICKER_CONSTANTS.selectors.BUTTON_SLOT);
        _this._input = getShadowElement(component, FILE_PICKER_CONSTANTS.selectors.INPUT);
        _this._inputEventListener = function () {
            _this._input.value = '';
            _this._input.click();
        };
        _this._container.addEventListener('click', _this._inputEventListener);
        return _this;
    }
    FilePickerAdapter.prototype.registerButtonSlotListener = function (listener) {
        this._buttonSlot.addEventListener('slotchange', listener);
    };
    FilePickerAdapter.prototype.registerInputChangeListener = function (listener) {
        this._input.addEventListener('change', listener);
    };
    FilePickerAdapter.prototype.registerDragEnterListener = function (listener) {
        this._container.addEventListener('dragenter', listener);
    };
    FilePickerAdapter.prototype.registerDragLeaveListener = function (listener) {
        this._container.addEventListener('dragleave', listener);
    };
    FilePickerAdapter.prototype.registerDragOverListener = function (listener) {
        this._container.addEventListener('dragover', listener);
    };
    FilePickerAdapter.prototype.registerDropListener = function (listener) {
        this._container.addEventListener('drop', listener);
    };
    FilePickerAdapter.prototype.removeDragEnterListener = function (listener) {
        this._container.removeEventListener('dragenter', listener);
    };
    FilePickerAdapter.prototype.removeDragLeaveListener = function (listener) {
        this._container.removeEventListener('dragleave', listener);
    };
    FilePickerAdapter.prototype.removeDragOverListener = function (listener) {
        this._container.removeEventListener('dragover', listener);
    };
    FilePickerAdapter.prototype.removeDropListener = function (listener) {
        this._container.removeEventListener('drop', listener);
    };
    FilePickerAdapter.prototype.initializeButton = function () {
        var button = this._component.querySelector('button');
        this._button = button || undefined;
    };
    /**
     * Sets the highlight state of the file picker.
     * @param value True if the highlight should be applied and false if not.
     */
    FilePickerAdapter.prototype.setHighlightState = function (value) {
        if (this._container.classList.contains(FILE_PICKER_CONSTANTS.classes.HIGHLIGHT) !== value) {
            this._container.classList.toggle(FILE_PICKER_CONSTANTS.classes.HIGHLIGHT);
        }
    };
    /**
     * Sets the accept attribute of the input.
     * @param value The accept string.
     */
    FilePickerAdapter.prototype.setAccept = function (value) {
        if (value) {
            this._input.setAttribute('accept', value);
        }
        else {
            this._input.removeAttribute('accept');
        }
    };
    /**
     * Sets the capture attribute of the input.
     * @param value The capture string.
     */
    FilePickerAdapter.prototype.setCapture = function (value) {
        if (value) {
            this._input.setAttribute('capture', value);
        }
        else {
            this._input.removeAttribute('capture');
        }
    };
    /**
     * Sets the multiple attribute of the input.
     * @param value The multiple state.
     */
    FilePickerAdapter.prototype.setMultiple = function (value) {
        if (value) {
            this._input.setAttribute('multiple', '');
        }
        else {
            this._input.removeAttribute('multiple');
        }
    };
    /**
     * Sets the disabled state of the file picker.
     * @param value The disabled state.
     */
    FilePickerAdapter.prototype.setDisabled = function (value) {
        if (value) {
            this._container.removeEventListener('click', this._inputEventListener);
            this._button.setAttribute('disabled', '');
            this._container.setAttribute('disabled', '');
        }
        else {
            this._container.addEventListener('click', this._inputEventListener);
            this._button.removeAttribute('disabled');
            this._container.removeAttribute('disabled');
        }
    };
    /**
     * Sets the compact state of the file picker.
     * @param value The compact state.
     */
    FilePickerAdapter.prototype.setCompact = function (value) {
        if (this._container.classList.contains(FILE_PICKER_CONSTANTS.classes.COMPACT) !== value) {
            this._container.classList.toggle(FILE_PICKER_CONSTANTS.classes.COMPACT);
        }
    };
    /**
     * Sets the borderless state of the file picker.
     * @param value The borderless state.
     */
    FilePickerAdapter.prototype.setBorderless = function (value) {
        if (this._container.classList.contains(FILE_PICKER_CONSTANTS.classes.BORDERLESS) !== value) {
            this._container.classList.toggle(FILE_PICKER_CONSTANTS.classes.BORDERLESS);
        }
    };
    return FilePickerAdapter;
}(BaseAdapter));
export { FilePickerAdapter };
